import React from "react";
import { Link } from "react-router-dom";

export const Footer = () => (
  <footer data-testid="site-footer" className="mt-16 border-t border-[#E2DCD2] bg-[#F4F0E8]">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8 flex flex-col sm:flex-row items-center justify-between gap-3">
      <div className="flex flex-col items-center sm:items-start gap-1">
        <p className="text-sm text-[#5C564E]">© {new Date().getFullYear()} BidMark Quotes</p>
        <p className="text-xs text-[#5C564E] flex gap-3">
          <Link to="/privacy" data-testid="footer-privacy-link" className="underline underline-offset-2 hover:text-[#A6844A] transition-colors">Privacy Policy</Link>
          <Link to="/terms" data-testid="footer-terms-link" className="underline underline-offset-2 hover:text-[#A6844A] transition-colors">Terms of Service</Link>
        </p>
      </div>
      <p className="text-sm text-[#5C564E] flex flex-col sm:flex-row items-center gap-1 sm:gap-4">
        <span>
          Contact us:{" "}
          <a
            data-testid="footer-contact-email"
            href="mailto:info@bidmarkquotes.com"
            className="text-[#1B3A4B] font-medium underline underline-offset-2 hover:text-[#A6844A] transition-colors"
          >
            info@bidmarkquotes.com
          </a>
        </span>
        <span>
          Support:{" "}
          <a
            data-testid="footer-support-phone"
            href="tel:+18575203500"
            className="text-[#1B3A4B] font-medium underline underline-offset-2 hover:text-[#A6844A] transition-colors"
          >
            (857) 520-3500
          </a>
        </span>
      </p>
    </div>
  </footer>
);
